import React from "react";

function Box({ icon, lable, number, col }) {
  return (
    <div
      className={col}
      style={{
        border: "3px solid rgba(0, 153, 255, 0.9)",
        borderRadius: "25px",
        padding: "17px 10px 17px 10px",
        color: "white",
        textAlign: "center",
        fontSize: "19px",
        fontWeight: "400",
        lineHeight: "35px",
        letterSpacing: "0em",
        color: "rgba(0, 153, 255, 0.9)"
      }}
    >
      <div>
        <span className="ms-3">
          {icon}
        </span>
        {lable}
      </div>

      <div style={{
        fontSize: "25px",
        borderBottom: "1px solid",
        width: "max-content",
        margin: "auto",
        padding: "0 20px"
      }}>
        {number}
      </div>

    </div >
  );
}

export default Box;
